import { z } from 'zod';

// SECTION: --------------------- Validators/Schemas ---------------------

export const ExternalShopShippingCountrySchema = z.object({
    id: z.number(),
    twoCharCode: z.string(),
    threeCharCode: z.string(),
    displayName: z.string(),
});

export const ClientShopShippingCountrySchema = z.object({
    id: z.number(),
    clientShopId: z.number(),
    countryId: z.number(),
    shippingGroupId: z.number().nullable(),
    twoCharCode: z.string(),
    threeCharCode: z.string(),
    displayName: z.string(),
});

export const ShopPlatformSchema = z.enum([
    'shopify',
    'bigcommerce',
    'woocommerce',
    'adobe',
    'custom',
]);

export const ClientShopSchema = z.object({
    id: z.number(),
    clientId: z.number(),
    publicShopUrl: z.string(),
    currency: z.string().nullable(),
    shopAdminUrl: z.string().nullable(),
    apiPlatform: ShopPlatformSchema,
    isReadyAuth: z.boolean(),
    isAuthed: z.boolean(),
    nickname: z.string().nullable(),
    apiHost: z.string().nullable(),
    shopTimeZone: z.string().nullable(),
    shopOldTimeZone: z.string().nullable(),
    isShopifyPlus: z.boolean().nullable(),
    isDisconnected: z.boolean().nullable(),
    inventoryTracking: z.boolean(),
    deletedAt: z.string().nullable(),
    numberOfShippingCountries: z.number(),
    shippingGroupId: z.number().nullable(),
    pixelIdentifier: z.string().nullable(),
    sellsSubscriptions: z.boolean(),
    forceReAuth: z.boolean(),
    usingPublicApp: z.boolean(),
    useNewSeedingFlow: z.boolean(),
    installWebPixel: z.boolean(),
    webPixelInstalled: z.boolean(),
});

export const ClientShopShippingGroupSchema = z.object({
    id: z.number(),
    clientShopId: z.number(),
    shippingGroupId: z.number(),
    name: z.string(),
});

export const ShippingGroupSchema = z.object({
    id: z.number(),
    clientId: z.number(),
    name: z.string(),
});

// SECTION: --------------------- Types ---------------------

export type ClientShop = z.infer<typeof ClientShopSchema>;

export type ShopPlatform = z.infer<typeof ShopPlatformSchema>;
export type ClientShopShippingCountry = z.infer<typeof ClientShopShippingCountrySchema>;

export type ExternalShopShippingCountry = z.infer<typeof ExternalShopShippingCountrySchema>;

export type ClientShopShippingGroup = z.infer<typeof ClientShopShippingGroupSchema>;

export type ShippingGroup = z.infer<typeof ShippingGroupSchema>;
